import { NavLink as RouterNavLink } from 'react-router-dom';

import { useNavigationStore } from '@/stores/navigation';

import type { NavItem } from '@/types/navigation';
import type { ReactNode } from 'react';

type NavLinkProps = { item: NavItem };

const getStyle = (isActive: boolean): React.CSSProperties => ({
  background: isActive ? 'var(--surface-elevated)' : 'transparent',
  color: isActive ? 'var(--chartreuse)' : 'var(--text-secondary)',
  borderColor: isActive ? 'var(--border-subtle)' : 'transparent',
});

export function NavLink({ item }: NavLinkProps): ReactNode {
  const setMobileMenu = useNavigationStore((s) => s.setMobileMenu);
  const Icon = item.icon;
  const cls =
    'flex items-center gap-3 px-3 py-2.5 rounded-lg text-[13px] font-medium whitespace-nowrap overflow-hidden border hover:bg-[#1A1A1A]';
  return (
    <RouterNavLink
      to={item.path}
      end
      style={({ isActive }) => getStyle(isActive)}
      className={cls}
      onClick={() => setMobileMenu(false)}
    >
      <Icon className="w-4 h-4 shrink-0" />
      <span className="whitespace-nowrap">{item.label}</span>
    </RouterNavLink>
  );
}
